module.exports = __webpack_public_path__ + "static/media/arnav_prasad.1a2265cb.png";